import generic_backend_request_get from 'functions/server/generic_backend_request_get';

async function get_plans() {
    /**
     * Fetches the public plan catalog from the backend.
     *
     * GET /plans — no auth, no body; an immutable, cacheable catalog. Returns the
     * array of PublicPlan objects (the `data` of the {success, data, error}
     * envelope, unwrapped by the GET helper). Each plan is:
     *   tier     - the stable join key (e.g. "professional"); matches
     *              loginData.plan. NOT id/slug/name.
     *   planName - display name from the Clerk dashboard (nullable; never join
     *              on it — it can be renamed).
     *   limits   - per-table row caps (see PlanLimits).
     *   features - Object<String, Boolean>: the entitlement map that drives
     *              premium feature gating. Only overrides appear; an absent key
     *              falls back to the registry default (fail-open on the FE too).
     *
     * The endpoint may not be live on every environment yet; when it's absent the
     * request throws and the caller (the fetchPlans thunk) records a failed
     * status. Feature gating fails open in that case. See
     * functions/entitlements/featureEntitlements.
     *
     * @return {Array<Object>} The list of plans (may be empty).
     */
    const retJson = await generic_backend_request_get('/plans');
    return retJson;
}

export default get_plans;
